import QRCode from 'qrcode';

/**
 * Builds an <img> tag containing a QR code that links to a dress's public product page.
 * Returns '' if the salon has no public catalogue slug configured (no valid URL to encode).
 */
export async function getProductPageQrCodeImg(salonSlug, dressId) {
  if (!salonSlug || !dressId) return '';

  const base = typeof window !== 'undefined' ? window.location.origin : '';
  const url = `${base}/shops/${salonSlug}/dress/${dressId}`;

  try {
    const dataUrl = await QRCode.toDataURL(url, { width: 300, margin: 1 });
    return `<span class="declaration-qr-code-wrap"><img src="${dataUrl}" alt="" class="declaration-qr-code" /></span>`;
  } catch (err) {
    console.error('Error generating QR code:', err);
    return '';
  }
}

export const QR_CODE_PRINT_CSS = `
  .declaration-qr-code-wrap {
    display: inline-block;
    line-height: 0;
  }
  .declaration-qr-code {
    width: 2cm;
    height: 2cm;
  }
`;
